<gen-overlay-loader *ngIf="loader$ | async"></gen-overlay-loader>

<ispm-notification [configuration]="notificationConfig|async"></ispm-notification>

<div *ngIf="navigationEndIsTriggered" class="main-view ui-view">
  <div class="template-loader-container">
    <div class="loader-items">
      <span class="init-loader"></span>
      <div class="text-loader">
        <span>{{LOADER_TEXT}}</span>
      </div>
    </div>
  </div>
</div>

<router-outlet class="main-view ui-view"></router-outlet>

<gen-dynamic-modal-loader></gen-dynamic-modal-loader>

<gen-dynamic-modal-loader [observableName]="'patientDuplicatePopupChannel'"></gen-dynamic-modal-loader>

<gen-notification-message></gen-notification-message>
